'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _reactBootstrap = require('react-bootstrap');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _CodeEditor = require('../CodeEditor');

var _CodeEditor2 = _interopRequireDefault(_CodeEditor);

var _ContentMessage = require('../ContentMessage');

var _ContentMessage2 = _interopRequireDefault(_ContentMessage);

var _HTTPResponseLabel = require('../HTTPResponseLabel');

var _HTTPResponseLabel2 = _interopRequireDefault(_HTTPResponseLabel);

var _FormControl = require('../FormControl');

var _FormControl2 = _interopRequireDefault(_FormControl);

var _util = require('./util');

var _JsonSchema = require('../JsonSchema');

var _JsonSchema2 = _interopRequireDefault(_JsonSchema);

var _Form = require('../Form');

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint jsx-a11y/label-has-for:0 */


var sortParameterByName = function sortParameterByName(a, b) {
	if (a.name < b.name) {
		return -1;
	}
	if (a.name > b.name) {
		return 1;
	}
	return 0;
};

var INPUT_TYPE_MAP = {
	number: 'number',
	integer: 'number',
	date: 'date',
	string: 'text',
	boolean: 'checkbox',
	object: 'text',
	array: 'text',
	file: 'file'
};

var MethodTest = function (_React$Component) {
	_inherits(MethodTest, _React$Component);

	function MethodTest(props) {
		_classCallCheck(this, MethodTest);

		var _this = _possibleConstructorReturn(this, (MethodTest.__proto__ || Object.getPrototypeOf(MethodTest)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		var doc = props.doc,
		    path = props.path,
		    verb = props.verb;

		_this.state = {
			params: (0, _util.getParametersForMethod)(doc, path, verb),
			validationState: null,
			form: null
		};

		_this.onFieldChange = _this.onFieldChange.bind(_this);
		_this.onClear = _this.onClear.bind(_this);
		_this.onExecute = _this.onExecute.bind(_this);

		//
		// Details for Test API actions.
		//
		_this.actions = {
			POST: {
				passive: _this.intl.formatMsg('Create'),
				active: _this.intl.formatMsg('Creating'),
				execute: function execute(fn) {
					return fn();
				}
			},
			PUT: {
				passive: _this.intl.formatMsg('Update'),
				active: _this.intl.formatMsg('Updating'),
				execute: function execute(fn) {
					return fn();
				}
			},
			DELETE: {
				passive: _this.intl.formatMsg('Delete'),
				active: _this.intl.formatMsg('Deleting'),
				bsStyle: 'danger',
				glyph: 'trash',
				confirmation: _this.intl.formatMsg('Are you sure?'),
				execute: function execute(fn) {
					return _this.confirmExecute(fn);
				}
			},
			EXECUTE: {
				passive: _this.intl.formatMsg('Execute'),
				active: _this.intl.formatMsg('Executing'),
				execute: function execute(fn) {
					return fn();
				}
			}
		};

		//
		// Intl Labels for parameters section.
		//
		_this.paramTypes = {
			body: _this.intl.formatMsg('Body parameters'),
			header: _this.intl.formatMsg('Header parameters'),
			path: _this.intl.formatMsg('Path parameters'),
			query: _this.intl.formatMsg('Query parameters'),
			formData: _this.intl.formatMsg('Form data parameters')
		};
		return _this;
	}

	_createClass(MethodTest, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.resetFormState();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(props) {
			var doc = props.doc,
			    path = props.path,
			    verb = props.verb;

			this.setState({
				params: (0, _util.getParametersForMethod)(doc, path, verb)
			});
		}
	}, {
		key: 'validateParameterField',
		value: function validateParameterField(location, name) {
			var valid = true;
			var form = this.state.form;
			var param = void 0;

			if (name === undefined) {
				// passed the param as the first arg
				param = location;
			} else {
				// Need to look it up.
				param = this.state.params.find(function (p) {
					return p.name === name && p.in === location;
				});
			}

			// TODO: [AXUI-6] More than just required field validation
			if (param.required && param.in === 'body') {
				// Body value gets stored as a string so try and parse it
				// This will have to all change when we support non-json types
				var value = form.body;

				try {
					value = JSON.parse(value);
				} catch (e) {
					// ignore errors and leave the value (may not be json)
				}
				valid = value !== undefined && value !== '';
			} else if (param.required || param.in === 'path') {
				var _value = form[param.in] && form[param.in][param.name];
				valid = _value !== undefined && _value !== null && _value !== '';
			}
			var validationState = _extends({}, this.state.validationState, _defineProperty({}, param.in, _extends({}, this.state.validationState[param.in])));
			if (valid) {
				delete validationState[param.in][param.name];
			} else {
				validationState[param.in][param.name] = 'error';
			}

			this.setState({ validationState: validationState });
			return valid;
		}
	}, {
		key: 'validateForm',
		value: function validateForm() {
			var valid = true;
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = this.state.params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var param = _step.value;

					valid = valid && this.validateParameterField(param);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return valid;
		}
	}, {
		key: 'resetFormState',
		value: function resetFormState() {
			var _props = this.props,
			    method = _props.method,
			    doc = _props.doc,
			    path = _props.path,
			    verb = _props.verb;

			var consumes = (0, _util.getConsumes)(method, doc, path, verb);
			var produces = (0, _util.getProduces)(method, doc);

			this.setState({
				validationState: {
					path: {},
					query: {},
					header: {},
					body: {},
					formData: {}
				},
				form: {
					request: {
						contentType: consumes && consumes.length && consumes.sort()[0],
						accept: produces && produces.length && produces.sort()[0]
					},
					path: {},
					query: {},
					header: {},
					body: undefined,
					formData: {}
				}
			});
		}
	}, {
		key: 'cancelConfirmExecute',
		value: function cancelConfirmExecute() {
			this.context.setDialog && this.context.setDialog(null);
		}
	}, {
		key: 'confirmExecute',
		value: function confirmExecute(fn) {
			var _this2 = this;

			var verb = this.props.verb;

			var executeLabel = this.actions[verb.toUpperCase()] || this.actions.EXECUTE;

			this.context.setDialog && this.context.setDialog(_react2.default.createElement(_ContentMessage2.default, {
				confirm: true,
				className: 'lg warning',
				detail: executeLabel.confirmation,
				actionLabel: executeLabel.passive,
				cancelLabel: this.intl.formatMsg('Cancel'),
				onAction: function onAction() {
					_this2.cancelConfirmExecute();
					return fn();
				},
				actionGlyph: executeLabel.glyph,
				actionClass: executeLabel.bsStyle && 'btn-' + executeLabel.bsStyle,
				onClose: function onClose() {
					return _this2.cancelConfirmExecute();
				},
				onCancel: function onCancel() {
					return _this2.cancelConfirmExecute();
				},
				imgClass: 'gg icon-GG-warning'
			}));
		}

		/**
   * Store the content of the test api input fields.
   */

	}, {
		key: 'onFieldChange',
		value: function onFieldChange(location, name, value) {
			var _this3 = this;

			var enableFormParameterSupport = this.props.enableFormParameterSupport;

			var newFormState = _extends({}, this.state.form);
			if (location === 'body') {
				newFormState.body = value;
			} else if (value === undefined && newFormState[location]) {
				delete newFormState[location][name];
			} else {
				newFormState[location] = newFormState[location] || {};
				newFormState[location][name] = value;
			}

			this.setState({
				form: newFormState
			}, function () {
				if (location === 'header' || location === 'query' || location === 'path' || enableFormParameterSupport && location === 'formData') {
					_this3.validateParameterField(location, name);
				}
			});
		}

		/**
   * Execute the API with the form parameters.
   */

	}, {
		key: 'onExecute',
		value: function onExecute() {
			if (!this.validateForm()) {
				return;
			}

			var _props2 = this.props,
			    verb = _props2.verb,
			    path = _props2.path,
			    enableFormParameterSupport = _props2.enableFormParameterSupport;

			var form = this.state.form;
			var pathParams = {};
			var headerParams = {};
			var queryParams = {};
			var formParams = {};

			if (form && form.path) {
				Object.keys(form.path).forEach(function (name) {
					pathParams[name] = form.path[name];
				});
			}

			if (form && form.header) {
				Object.keys(form.header).forEach(function (name) {
					headerParams[name] = form.header[name];
				});
			}

			if (form && form.query) {
				Object.keys(form.query).forEach(function (name) {
					queryParams[name] = form.query[name];
				});
			}

			if (form && form.formData) {
				Object.keys(form.formData).forEach(function (name) {
					formParams[name] = form.formData[name];
				});
			}

			// BODY
			var bodyParams = form.body || '';
			var params = {
				path: pathParams,
				header: headerParams,
				query: queryParams,
				body: bodyParams
			};
			if (enableFormParameterSupport) {
				params.formData = formParams;
			}
			this.props.onExecute({
				verb: verb,
				path: path,
				uri: '' + (this.props.doc.basePath || '') + (0, _util.expandPath)(path, pathParams, queryParams),
				contentType: form.request.contentType,
				accept: form.request.accept,
				params: params
			});
		}

		/**
   * Clear the Test API form.
   */

	}, {
		key: 'onClear',
		value: function onClear() {
			var _props3 = this.props,
			    verb = _props3.verb,
			    path = _props3.path;

			this.resetFormState();
			this.state.formElem && this.state.formElem.reset && this.state.formElem.reset();
			this.props.onClear({ verb: verb, path: path });
		}
	}, {
		key: 'renderRequest',
		value: function renderRequest() {
			var _this4 = this;

			var _props4 = this.props,
			    isExecuting = _props4.isExecuting,
			    isDisabled = _props4.isDisabled,
			    method = _props4.method,
			    doc = _props4.doc,
			    path = _props4.path,
			    verb = _props4.verb;

			var contentType = (0, _util.getConsumes)(method, doc, path, verb).sort().map(function (type) {
				return _react2.default.createElement(
					'option',
					{ key: 'contenttype_' + type, value: type },
					type
				);
			});
			var accept = ((0, _util.getProduces)(method, doc) || []).map(function (type) {
				return _react2.default.createElement(
					'option',
					{ key: 'accept_' + type, value: type },
					type
				);
			});
			var fields = [_react2.default.createElement(
				_reactBootstrap.FormGroup,
				{ key: 'request-contenttype', controlId: 'frm_request-contenttype' },
				_react2.default.createElement(
					_reactBootstrap.Col,
					{ componentClass: _reactBootstrap.ControlLabel, sm: 12 },
					_react2.default.createElement(
						_reactBootstrap.OverlayTrigger,
						{
							placement: 'right',
							overlay: _react2.default.createElement(
								_reactBootstrap.Tooltip,
								{ id: 'tooltip' },
								this.intl.formatMsg('The MIME type of the request body.')
							)
						},
						_react2.default.createElement(
							'span',
							null,
							this.intl.formatMsg('Content-Type')
						)
					)
				),
				_react2.default.createElement(
					_reactBootstrap.Col,
					{ sm: 11 },
					_react2.default.createElement(
						_FormControl2.default,
						{
							className: 'contentType',
							componentClass: 'select',
							disabled: isExecuting || isDisabled || contentType.length === 0,
							onChange: function onChange(event) {
								_this4.onFieldChange('request', 'contentType', event.target.value);
							}
						},
						contentType
					)
				)
			), _react2.default.createElement(
				_reactBootstrap.FormGroup,
				{ key: 'request-accept', controlId: 'frm_request-accept' },
				_react2.default.createElement(
					_reactBootstrap.Col,
					{ componentClass: _reactBootstrap.ControlLabel, sm: 12 },
					_react2.default.createElement(
						_reactBootstrap.OverlayTrigger,
						{
							placement: 'right',
							overlay: _react2.default.createElement(
								_reactBootstrap.Tooltip,
								{ id: 'tooltip' },
								this.intl.formatMsg('The MIME types that are acceptable for the response.')
							)
						},
						_react2.default.createElement(
							'span',
							null,
							this.intl.formatMsg('Accept')
						)
					)
				),
				_react2.default.createElement(
					_reactBootstrap.Col,
					{ sm: 11 },
					_react2.default.createElement(
						_FormControl2.default,
						{
							className: 'accept',
							componentClass: 'select',
							disabled: isExecuting || isDisabled || accept.length === 0,
							onChange: function onChange(event) {
								_this4.onFieldChange('request', 'accept', event.target.value);
							}
						},
						accept
					)
				)
			)];
			var rowCount = Math.ceil(fields.length / 2);
			return _react2.default.createElement(
				'fieldset',
				{ className: 'params request' },
				_react2.default.createElement(
					'legend',
					null,
					this.intl.formatMsg('Request')
				),
				_react2.default.createElement(
					_reactBootstrap.Row,
					null,
					_react2.default.createElement(
						_reactBootstrap.Col,
						{ sm: 6, xs: 12 },
						fields.splice(0, rowCount)
					),
					_react2.default.createElement(
						_reactBootstrap.Col,
						{ sm: 6, xs: 12 },
						fields
					)
				)
			);
		}

		/**
   * Render an inputs for the method parameters.
   */

	}, {
		key: 'renderParameters',
		value: function renderParameters(parameters, location) {
			if (!parameters || !parameters[location] || parameters[location].length === 0) {
				return null;
			}

			var _props5 = this.props,
			    isExecuting = _props5.isExecuting,
			    isDisabled = _props5.isDisabled,
			    enableFormParameterSupport = _props5.enableFormParameterSupport;


			if (location === 'body') {
				return this.renderBodyParameters(parameters[location], location, isExecuting, isDisabled);
			} else {
				return this.renderURLorFormParameters(parameters[location], location, isExecuting, isDisabled, enableFormParameterSupport);
			}
		}

		/**
   * Render an inputs for the method parameters that are on the URL (query & path) or on formData.
   */

	}, {
		key: 'renderURLorFormParameters',
		value: function renderURLorFormParameters(params, location, isExecuting, isDisabled, enableFormParameterSupport) {
			var _this5 = this;

			var customParameterRenderers = this.props.customParameterRenderers;

			var fields = params.sort(sortParameterByName).map(function (param) {
				var element = void 0;
				var currentValue = _this5.state.form[location][param.name];
				if (customParameterRenderers.length) {
					var renderer = _this5.extractCustomRenderer(param);
					if (renderer) {
						element = renderer.render(param, currentValue, function (value) {
							_this5.onFieldChange(location, param.name, value);
						});

						if (element === null) {
							return element;
						}
					}
				}

				if (!element) {
					if (currentValue === undefined) {
						// some special cases due to limitiations in the UI require some smart defaults
						if (param.default !== undefined) {
							currentValue = _this5.state.form[location][param.name] = param.default;
						} else if (param.required || param.in === 'path') {
							if (param.type === 'boolean') {
								// There's no way of choosing to provide a boolean field or not. The UI will
								// validate a required boolean input as invalid even though it displays as "false"
								// unless we set the internal value to false.
								currentValue = _this5.state.form[location][param.name] = false;
							} else if (param.type === 'file') {
								currentValue = _this5.state.form[location][param.name] = {};
							} else {
								currentValue = _this5.state.form[location][param.name] = '';
							}
						}
					}
					if (param.type === 'file' && enableFormParameterSupport) {
						element = _react2.default.createElement(_FormControl2.default.File, {
							buttonStyle: 'default',
							value: currentValue,
							className: 'param_' + param.name,
							onChange: function onChange(file) {
								return _this5.onFieldChange(location, param.name, file);
							},
							disabled: isExecuting || isDisabled
						});
					} else {
						element = _react2.default.createElement(_FormControl2.default, {
							className: 'param_' + param.name,
							type: INPUT_TYPE_MAP[param.type] || 'text',
							value: currentValue,
							placeholder: param.type || 'string',
							disabled: isExecuting || isDisabled,
							onChange: function onChange(event) {
								param.type === 'boolean' ? _this5.onFieldChange(location, param.name, event.target.checked) : _this5.onFieldChange(location, param.name, event.target.value);
							}
						});
					}
				}

				var tooltip = _react2.default.createElement(
					_reactBootstrap.Tooltip,
					{ id: 'tooltip' },
					param.description
				);
				var title = param.description ? _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ placement: 'right', overlay: tooltip },
					_react2.default.createElement(
						'span',
						null,
						param.name
					)
				) : _react2.default.createElement(
					'span',
					null,
					param.name
				);

				return _react2.default.createElement(
					_reactBootstrap.FormGroup,
					{
						key: param.name + '_' + param.in,
						controlId: 'frm_' + param.name + '_' + param.in,
						validationState: _this5.state.validationState[param.in][param.name]
					},
					_react2.default.createElement(
						_reactBootstrap.Col,
						{ componentClass: _reactBootstrap.ControlLabel, sm: 12 },
						title
					),
					_react2.default.createElement(
						_reactBootstrap.Col,
						{ sm: 11 },
						element,
						_this5.state.validationState[param.in] && _this5.state.validationState[param.in][param.name] === 'error' && _react2.default.createElement(_FormControl2.default.Feedback, null)
					)
				);
			});

			var rowCount = Math.ceil(params.length / 2);
			return _react2.default.createElement(
				'fieldset',
				{ className: (0, _classnames2.default)('params', location) },
				_react2.default.createElement(
					'legend',
					null,
					this.paramTypes[location]
				),
				_react2.default.createElement(
					_reactBootstrap.Row,
					null,
					_react2.default.createElement(
						_reactBootstrap.Col,
						{ sm: 6, xs: 12 },
						fields.splice(0, rowCount)
					),
					_react2.default.createElement(
						_reactBootstrap.Col,
						{ sm: 6, xs: 12 },
						fields
					)
				)
			);
		}

		/**
   * If current parameter satisfy custom renderer preconditions extract the element from the render function.
   * The onChange handler will receive the value from the event.
   *
   * @param param
   * @return {*}
   */

	}, {
		key: 'extractCustomRenderer',
		value: function extractCustomRenderer(param) {
			var customParameterRenderers = this.props.customParameterRenderers;


			return customParameterRenderers.find(function (renderer) {
				if (renderer.precondition.type !== param.type) {
					return false;
				}

				return !('test' in renderer.precondition) || renderer.precondition.test(param);
			});
		}

		/**
   * Render input for the method parameters that are on the body.
   */

	}, {
		key: 'renderBodyParameters',
		value: function renderBodyParameters(bodyParams, location, isExecuting, isDisabled) {
			var _this6 = this;

			// There can be only one.
			if (bodyParams.length !== 1) {
				throw new Error('Invalid body parameters definition.');
			}
			var bodySchema = (0, _util.deref)(this.props.doc, bodyParams[0].schema);

			// Filter out the readOnly params.
			if (bodySchema.properties) {
				bodySchema.properties = Object.keys(bodySchema.properties).filter(function (p) {
					return !bodySchema.properties[p].readOnly;
				}).reduce(function (col, cur) {
					col[cur] = bodySchema.properties[cur];
					return col;
				}, {});
			}

			if (this.state.form.body === undefined) {
				this.state.form.body = JSON.stringify((0, _util.getDefaultsFromJSONSchema)(bodySchema), null, 2);
			}
			var body = this.state.form.body;
			return _react2.default.createElement(
				'fieldset',
				{ className: 'params body' },
				_react2.default.createElement(
					_reactBootstrap.FormGroup,
					{ key: 'body', controlId: 'frm_body' },
					_react2.default.createElement(
						_reactBootstrap.Col,
						{ componentClass: _reactBootstrap.ControlLabel, sm: 12 },
						_react2.default.createElement(
							'span',
							null,
							this.intl.formatMsg('Body Parameters')
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Col,
						{ sm: 6 },
						_react2.default.createElement(
							'span',
							null,
							this.intl.formatMsg('Body')
						),
						_react2.default.createElement(_CodeEditor2.default, {
							code: body,
							mode: 'json',
							scrollbarStyle: 'simple',
							lint: true,
							readOnly: isExecuting || isDisabled,
							onChange: function onChange(content) {
								_this6.onFieldChange('body', null, content);
							}
						})
					),
					_react2.default.createElement(
						_reactBootstrap.Col,
						{ sm: 6 },
						_react2.default.createElement(
							'span',
							null,
							this.intl.formatMsg('JSON Schema')
						),
						_react2.default.createElement(_JsonSchema2.default, { schema: bodySchema })
					)
				)
			);
		}
	}, {
		key: 'getExecuteButton',
		value: function getExecuteButton() {
			var _this7 = this;

			var verb = this.props.verb;
			var _props6 = this.props,
			    isExecuting = _props6.isExecuting,
			    isDisabled = _props6.isDisabled;

			var executeLabel = this.actions[verb.toUpperCase()] || this.actions.EXECUTE;

			return _react2.default.createElement(
				_reactBootstrap.Button,
				{
					type: 'submit',
					bsSize: 'large',
					bsStyle: executeLabel.bsStyle || 'primary',
					className: 'compact',
					onClick: function onClick(e) {
						e && e.preventDefault();
						executeLabel.execute(_this7.onExecute);
					},
					disabled: isExecuting || isDisabled
				},
				isExecuting && _react2.default.createElement('div', { className: 'spin' }),
				!isExecuting && executeLabel.glyph && _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: executeLabel.glyph }),
				isExecuting ? executeLabel.active : executeLabel.passive
			);
		}
	}, {
		key: 'getCancelButton',
		value: function getCancelButton() {
			var _this8 = this;

			var _props7 = this.props,
			    isExecuting = _props7.isExecuting,
			    verb = _props7.verb,
			    path = _props7.path;


			return _react2.default.createElement(
				_reactBootstrap.Button,
				{
					type: 'button',
					bsSize: 'large',
					className: 'compact',
					onClick: function onClick() {
						return _this8.props.onCancel({ verb: verb, path: path });
					},
					disabled: !isExecuting
				},
				_react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: ' gg icon-GG-cross' }),
				this.intl.formatMsg('Cancel')
			);
		}
	}, {
		key: 'getMessageIsDisabled',
		value: function getMessageIsDisabled() {
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: ' gg icon-GG-info' }),
				' ',
				_react2.default.createElement(
					'span',
					{ className: 'is-disabled-message' },
					this.props.isDisabledMessage
				)
			);
		}
	}, {
		key: 'getClearButton',
		value: function getClearButton() {
			var isExecuting = this.props.isExecuting;


			return _react2.default.createElement(
				_reactBootstrap.Button,
				{
					type: 'reset',
					bsSize: 'large',
					className: 'compact',
					onClick: this.onClear,
					disabled: isExecuting
				},
				_react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: ' gg icon-GG-cross' }),
				this.intl.formatMsg('Clear')
			);
		}

		/**
   * Render the response for the API call.
   */

	}, {
		key: 'renderResponse',
		value: function renderResponse() {
			var response = this.props.response;
			if (!response) {
				return null;
			}

			var isError = response instanceof Error;
			var respBody = void 0;

			if (isError) {
				respBody = response.message || this.intl.formatMsg('Unexpected error when attempting to test API.');
			} else if (response.data !== null && ['boolean', 'number', 'object'].includes(_typeof(response.data))) {
				// Stringify specific non-string/non-null responses
				// all numbers (including 0)
				// true/false booleans
				// objects/arrays
				respBody = JSON.stringify(response.data, null, 2);
			} else {
				respBody = response.data;
			}
			// If respBody ends up as an an empty string, null or undefined, it will not render a body.

			// Format the response headers object
			var respHeaders = response.headers && Object.keys(response.headers).reduce(function (prev, cur) {
				return prev + '\n' + cur + ': ' + response.headers[cur];
			}, '').trim();

			return _react2.default.createElement(
				'div',
				{ className: 'response' },
				_react2.default.createElement(
					_reactBootstrap.Row,
					null,
					_react2.default.createElement(
						_reactBootstrap.Col,
						{ sm: 12 },
						_react2.default.createElement(
							'label',
							null,
							this.intl.formatMsg('Result')
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Col,
						{ className: 'summary', sm: 12 },
						response && !isError && response.status && _react2.default.createElement(
							'span',
							null,
							_react2.default.createElement(_HTTPResponseLabel2.default, {
								intl: this.intl,
								code: response.status
							})
						),
						response && isError && response.name && _react2.default.createElement(
							'span',
							{ className: 'ux-text-color-error' },
							response.name
						)
					),
					respHeaders && _react2.default.createElement(
						_reactBootstrap.Col,
						{ sm: 12, className: 'response-headers' },
						_react2.default.createElement(
							'span',
							null,
							this.intl.formatMsg('Response headers')
						),
						_react2.default.createElement(_CodeEditor2.default, {
							code: respHeaders,
							mode: 'headers',
							scrollbarStyle: 'simple',
							readOnly: true,
							lineNumbers: false
						})
					),
					respBody && _react2.default.createElement(
						_reactBootstrap.Col,
						{ sm: 12, className: 'response-body' },
						_react2.default.createElement(
							'span',
							null,
							this.intl.formatMsg('Response body')
						),
						_react2.default.createElement(_CodeEditor2.default, {
							code: respBody,
							mode: 'json',
							scrollbarStyle: 'simple',
							readOnly: true
						})
					)
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var _props8 = this.props,
			    isExecuting = _props8.isExecuting,
			    response = _props8.response,
			    isDisabled = _props8.isDisabled,
			    doc = _props8.doc,
			    path = _props8.path,
			    verb = _props8.verb,
			    enableFormParameterSupport = _props8.enableFormParameterSupport;

			var parameters = (0, _util.getParameters)(doc, path, verb);
			var isClearable = !!(response || parameters.path || parameters.query || parameters.body);

			return _react2.default.createElement(
				'div',
				{ className: 'ux-container' },
				_react2.default.createElement(
					'h4',
					null,
					this.props.heading
				),
				_react2.default.createElement(
					'div',
					{ className: 'methodtest-container' },
					_react2.default.createElement(
						_reactBootstrap.Col,
						{ sm: 12, className: 'methodtest' },
						_react2.default.createElement(
							_reactBootstrap.Row,
							null,
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ sm: 12 },
								_react2.default.createElement(
									_Form2.default,
									{ ref: function ref(elem) {
											_this9.state.formElem = elem;
										}, horizontal: true },
									this.renderRequest(),
									this.renderParameters(parameters, 'path'),
									this.renderParameters(parameters, 'header'),
									this.renderParameters(parameters, 'query'),
									this.renderParameters(parameters, 'body'),
									enableFormParameterSupport && this.renderParameters(parameters, 'formData'),
									_react2.default.createElement(
										_reactBootstrap.FormGroup,
										{ className: 'action' },
										_react2.default.createElement(
											_reactBootstrap.Col,
											{ sm: 12 },
											this.getExecuteButton(),
											isExecuting && this.getCancelButton(),
											isDisabled && this.getMessageIsDisabled(),
											!isExecuting && !isDisabled && isClearable && this.getClearButton()
										)
									)
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Row,
							null,
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ sm: 12 },
								this.renderResponse()
							)
						)
					)
				)
			);
		}
	}]);

	return MethodTest;
}(_react2.default.Component);

MethodTest.contextTypes = {
	setDialog: _propTypes2.default.func
};

MethodTest.propTypes = {
	/**
  * Test API heading
  */
	heading: _propTypes2.default.string.isRequired,

	/**
  * Swagger 2.0 method
  */
	method: _propTypes2.default.object.isRequired,

	/**
  * HTTP verb
  */
	verb: _propTypes2.default.string.isRequired,

	/**
  * HTTP path
  */
	path: _propTypes2.default.string.isRequired,

	/**
  * Valid swagger 2.0 document
  */
	doc: _propTypes2.default.object.isRequired,

	/**
  * The response to render.
  */
	response: _propTypes2.default.object,

	/**
  * Flag to indicate that the component should be
  * rendered in the executing state.
  */
	isExecuting: _propTypes2.default.bool,

	/**
  * Flag to disable the execute button
  */
	isDisabled: _propTypes2.default.bool,

	/**
  * Message to display if isDisabled prop is true
  */
	isDisabledMessage: _propTypes2.default.string,

	/**
  * Callback fired when the execute button is pressed.
  */
	onExecute: _propTypes2.default.func.isRequired,

	/**
  * Callback fired when the cancel execution button is pressed.
  */
	onCancel: _propTypes2.default.func.isRequired,

	/**
  * Callback fired when the form is cleared, allows
  * for clearing of parents state (e.g. response).
  */
	onClear: _propTypes2.default.func.isRequired,

	/**
  * Flag indicating whether or not there are listed form parameters
  */
	enableFormParameterSupport: _propTypes2.default.bool,

	/**
  * Custom renderers allowed to be used for MethodTest component under specific preconditions
  */
	customParameterRenderers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		precondition: _propTypes2.default.shape({
			type: _propTypes2.default.string.isRequired,
			test: _propTypes2.default.func
		}),
		render: _propTypes2.default.func.isRequired
	}))
};

MethodTest.defaultProps = {
	isExecuting: false,
	isDisabled: false,
	enableFormParameterSupport: false,
	customParameterRenderers: []
};

var _default = (0, _reactIntl.injectIntl)(MethodTest);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(sortParameterByName, 'sortParameterByName', 'src/components/SwaggerUI/MethodTest.jsx');

	__REACT_HOT_LOADER__.register(INPUT_TYPE_MAP, 'INPUT_TYPE_MAP', 'src/components/SwaggerUI/MethodTest.jsx');

	__REACT_HOT_LOADER__.register(MethodTest, 'MethodTest', 'src/components/SwaggerUI/MethodTest.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/SwaggerUI/MethodTest.jsx');
}();

;